import { render, staticRenderFns } from "./AddPriorityService.vue?vue&type=template&id=4a126184&"
import script from "./AddPriorityService.vue?vue&type=script&lang=js&"
export * from "./AddPriorityService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddPriorityService.vue"
export default component.exports